/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from "react";
import { Tooltip } from "@mui/material";

import * as Styles from "./historicoBody.styles";

interface Props {
  tipoAlteracao: string;
  valores: any;
}

const HistoricoAlteracao: React.FC<Props> = ({ tipoAlteracao, valores }) => {
  const [titleAlteracao, setTitleAlteracao] = useState<string>("Alteração");

  useEffect(() => {
    if (tipoAlteracao) {
      switch (tipoAlteracao) {
        case "AlteracaoTemperaturaLead":
          setTitleAlteracao("Temperatura");
          break;
        case "AlteracaoPreferencias":
          setTitleAlteracao("Preferencias");
          break;
        default:
          setTitleAlteracao("Alteração");
      }
    }
  });
  return (
    <>
      {valores.length < 1 ? (
        <Styles.BodyTarefas>
          <Styles.BodyAlteracao>
            <Styles.BodyAlteracao>
              <Styles.Text style={{ marginRight: 4 }}>
                {titleAlteracao}:
              </Styles.Text>
              <Styles.TagAlteracaoBody>
                <Styles.TagAlteracao className="depois">
                  Antes
                </Styles.TagAlteracao>
                <Styles.Text style={{ margin: "0 4px" }} className="arrow">
                  {"->"}
                </Styles.Text>
                <Styles.TagAlteracao className="antes">
                  Depois
                </Styles.TagAlteracao>{" "}
              </Styles.TagAlteracaoBody>
            </Styles.BodyAlteracao>
          </Styles.BodyAlteracao>
        </Styles.BodyTarefas>
      ) : (
        valores.map((valor: any, index: number) => (
          <Styles.BodyTarefas key={index}>
            <Styles.BodyAlteracao>
              <Styles.BodyAlteracao
                className={
                  valor?.campoAlterado === "Observação" ||
                  valor?.campoAlterado === "Observacoes"
                    ? "bodyObs"
                    : ""
                }
              >
                <Tooltip
                  title={
                    !valor?.campoAlterado || valor?.campoAlterado === " - "
                      ? "--"
                      : valor?.campoAlterado
                  }
                  placement="top"
                  arrow
                >
                  <Styles.Text
                    style={{ marginRight: 4 }}
                    className="textAlteracao"
                  >
                    {!valor?.campoAlterado || valor?.campoAlterado === " - "
                      ? "--"
                      : `${valor?.campoAlterado}: `}
                  </Styles.Text>
                </Tooltip>
                <Styles.TagAlteracaoBody
                  className={
                    valor?.campoAlterado === "Observação" ||
                    valor?.campoAlterado === "Observacoes"
                      ? "tagObs"
                      : ""
                  }
                >
                  <Tooltip
                    title={
                      !valor?.valorAntigo ||
                      valor?.valorAntigo === " - " ||
                      valor?.campoAlterado === "Observação" ||
                      valor?.campoAlterado === "Observacoes"
                        ? ""
                        : valor?.valorAntigo
                    }
                    placement="top"
                    arrow
                  >
                    <Styles.TagAlteracao className="depois">
                      {!valor?.valorAntigo || valor?.valorAntigo === " - "
                        ? "--"
                        : valor?.valorAntigo}
                    </Styles.TagAlteracao>
                  </Tooltip>
                  <Styles.Text style={{ margin: "0 4px" }} className="arrow">
                    {"->"}
                  </Styles.Text>
                  <Tooltip
                    title={
                      !valor?.valorNovo ||
                      valor?.valorNovo === " - " ||
                      valor?.campoAlterado === "Observação" ||
                      valor?.campoAlterado === "Observacoes"
                        ? ""
                        : valor?.valorNovo
                    }
                    placement="top"
                    arrow
                  >
                    <Styles.TagAlteracao className="antes">
                      {!valor?.valorNovo || valor?.valorNovo === " - "
                        ? "--"
                        : valor?.valorNovo}
                    </Styles.TagAlteracao>
                  </Tooltip>
                </Styles.TagAlteracaoBody>
              </Styles.BodyAlteracao>
            </Styles.BodyAlteracao>
          </Styles.BodyTarefas>
        ))
      )}
    </>
  );
};

export default HistoricoAlteracao;
